import gql from 'graphql-tag';

export const GET_MERIT = gql`
  query ($id: ID!) {
    merit(id: $id) {
      meritName
      awardBodyName
      awardDate
      country
      attainmentMeans
      supportingDocuments {
        id
        link
        name
      }
      _id
    }
  }
`;
